import React, { Component } from "react";
import { MnemoLoading, Title, SuccessNotification } from "components/misc";
import { Button, Container } from "design-react-kit";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { adminService, networkErrorHelper } from "libs";
import { MTable } from "components/table";

class ImportFromRecognition extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      selectedFile: null, // Stato per il file selezionato
      rndKey: Math.random(), // Chiave casuale per forzare il re-render della tabella
      payload: [], // Dati corsisti già in piattaforma
    };
  }

  tableConfig = {
    columns: [
      {
        id: "name",
        Header: "Nome",
        accessor: "Nome",
      },
      {
        id: "surname",
        Header: "Cognome",
        accessor: "Cognome",
      },
      {
        id: "registrationCode",
        Header: "Codice Registrazione",
        accessor: "Codice Registrazione",
      },
      {
        id: "cfuTD",
        Header: "CFU Tirocinio Diretto da svolgere",
        accessor: "Totale CFU di Tirocinio DIRETTO da svolgere",
      },
      {
        id: "userRecognition",
        Header: "Sigla Riconoscimento",
        accessor: "Sigla Riconoscimento",
      },
      {
        id: "edition",
        Header: "Edizione",
        accessor: "Edizione",
      }
    ],
  };

  //--- ---

  // Funzione per analizzare il contenuto del file selezionato
  previewFile = async () => {
    const { selectedFile } = this.state;
    if (!selectedFile) return;
    this.setState({ loading: true });

    try {
      const XLSX = require("xlsx");
      const data = await selectedFile.arrayBuffer();
      const workbook = XLSX.read(data);
      const firstSheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[firstSheetName];
      const jsonData = XLSX.utils.sheet_to_json(worksheet, {
        defval: "",
        raw: false,
        dateNF: "dd/mm/yyyy",
      });

      this.setState({
        payload: jsonData || [],
        rndKey: Math.random(), // Forza il re-render della tabella
      });

      this.setState({ loading: false });
    } catch (error) {
      console.error("Errore durante l'analisi del file:", error);
      this.setState({ loading: false });
      return;
    }
  }; //  previewFile

  // Funzione per inserire i dati nella piattaforma
  insertData = async () => {
    const { payload } = this.state;
    if (payload.length === 0) return;
    this.setState({ loading: true });

    adminService
      .ImportRecognitionCFUtd(payload)
      .then(({ data }) => {
        SuccessNotification.render(
          "Importazione andata a buon fine.",
          "Comunicazione",
        );

        this.setState({
          loading: false,
          selectedFile: null,
          payload: [],
          rndKey: Math.random(), // Forza il re-render della tabella
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          selectedFile: null,
        });

        networkErrorHelper.notify(error);
        console.log(error);
      });
  }; // insertData

  // Funzione per inviare il file all'API
  uploadFile = async () => {
    const { selectedFile } = this.state;

    if (!selectedFile) return;
    this.setState({ loading: true });
  };

  //--- ---

  render() {
    const { loading, selectedFile, payload } = this.state;

    return (
      <div className="container mt-3 mb-4">
        <section className="my-4">
          {loading ? (
            <MnemoLoading />
          ) : (
            <Container>
              <Title>Importazione Riconoscimenti:</Title>
              <hr />

              {payload.length === 0 ? (
                <div className="mt-4">
                  <div className="uploadForm">
                    {/* Input file nascosto */}
                    <input
                      className="uploadFormFile"
                      type="file"
                      accept=".xls,.xlsx"
                      onChange={(e) => {
                        const file = e.target.files[0];
                        this.setState({ selectedFile: file });
                      }}
                      style={{ display: "none" }}
                      ref={(input) => (this.fileInput = input)}
                    />

                    {/* Bottone per selezionare il file */}
                    <div className="wrapperUploadBtn">
                      <button
                        className="btn btn-primary bg-dark"
                        onClick={() => this.fileInput.click()}
                      >
                        Seleziona un file da importare
                      </button>

                      {selectedFile && (
                        <p className="uploadFileName">{selectedFile.name}</p>
                      )}
                    </div>

                    <button
                      className="btn btn-primary bg-dark"
                      onClick={this.previewFile}
                      disabled={!selectedFile}
                    >
                      ANTEPRIMA FILE
                    </button>

                    {/* Bottone per caricare il file 
                  <button
                    className="btn btn-primary bg-dark"
                    onClick={this.uploadFile}
                    disabled={!selectedFile}
                  >
                    IMPORTA FILE
                  </button>*/}
                  </div>
                </div>
              ) : (
                <div className="mt-4">
                  <Button
                    color="primary bg-danger m-2"
                    onClick={() => {
                      this.setState({
                        payload: [],
                        selectedFile: null,
                        rndKey: Math.random(), // Forza il re-render della tabella
                      });
                    }}
                  >
                    RESET
                  </Button>

                  <Button
                    color="primary bg-dark m-2"
                    onClick={() => {
                      this.insertData();
                    }}
                  >
                    CONFERMA DATI
                  </Button>
                </div>
              )}

              <hr />

              <div className="mt-4">
                <h2>Riconoscimenti da importare</h2>
                <MTable
                  key={this.state.rndKey}
                  tableData={this.state.payload}
                  tableConfig={this.tableConfig}
                />
              </div>
            </Container>
          )}
        </section>
      </div>
    );
  }
}

export default withRouter(ImportFromRecognition);
